import React, { useEffect, useRef, useState } from 'react'
import { AiOutlineSave } from 'react-icons/ai'

const faNumbers = require('../../../../../utils/numbersFa.js')

const WiscIVSequencing = ({access, counts, images, setSubExam, setScore, saveScore}) => {
 
    const [showStartButton, setShowStartButton] = useState(false)
    const [showNextButton, setShowNextButton] = useState(false)
    const [showQuestionCounter, setShowQuestionCounter] = useState(false)
    const [questionNumberStr, setQuestionNumberStr] = useState('')
    const [show0Score, setShow0Score] = useState(false)
    const [show1Score, setShow1Score] = useState(false)
    const [show2Score, setShow2Score] = useState(false)
    const [showTestList, setShowTestList] = useState(false)

    const farsiNumbers = faNumbers

 

    

    useEffect(() => {
        
        if (counts == 0) {
            setShowStartButton(true)
        } else {
            setShowStartButton(false)
        }
        if (counts == 17 || counts == 18) {
            setShowNextButton(true)
        } else {
            setShowNextButton(false)
        }
        if (counts > 0 && counts != 17 && counts != 18) {
            setShow0Score(true)
            setShow1Score(true)
            setShowQuestionCounter(true)
        } else {
            setShow0Score(false)
            setShow1Score(false)
            setShowQuestionCounter(false)
        }
        if (counts < 19) {
            setQuestionNumberStr(farsiNumbers[counts])
        } else {
            setQuestionNumberStr(farsiNumbers[counts - 2])
        }
        
    }, [counts])

    if (access != "User") {
        return (
            <div className='test-container'>
                <div className='d-flex w-80 justify-content-between align-items-center' style={{height: '5%', color: 'black', marginInlineStart: '10%', marginInlineEnd: '10%'}}>
                    {showStartButton &&
                    <div>{"۳۲ سوال"}</div>
                    }
                    {showNextButton &&
                    <div>{"نمونه"}</div>
                    }
                    {showQuestionCounter &&
                    <div>{questionNumberStr + "/۳۲"}</div>
                    }
                    <div className='d-flex flex-column' style={{position: 'relative', textAlign: 'end'}}>
                        <a style={{width: '75px', color: 'black'}} onClick={() => setShowTestList(!showTestList)}>{"توالی۱"}</a>
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '25px', color: 'black'}} onClick={() => setSubExam(0)}>{"مکعب‌ها"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '50px', color: 'black'}} onClick={() => setSubExam(1)}>{"شباهت‌ها"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '50px', color: 'gray'}} onClick={() => null}>{"توالی۱"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '75px', color: 'black'}} onClick={() => setSubExam(3)}>{"مفاهیم"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '100px', color: 'black'}} onClick={() => setSubExam(4)}>{"رمزنویسی"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '125px', color: 'black'}} onClick={() => setSubExam(5)}>{"واژگان"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '150px', color: 'black'}} onClick={() => setSubExam(6)}>{"توالی۲"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '175px', color: 'black'}} onClick={() => setSubExam(7)}>{"ماتریس‌ها"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '200px', color: 'black'}} onClick={() => setSubExam(8)}>{"درک مطلب"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '225px', color: 'black'}} onClick={() => setSubExam(9)}>{"نمادیابی"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '250px', color: 'black'}} onClick={() => setSubExam(10)}>{"تکمیل"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '275px', color: 'black'}} onClick={() => setSubExam(11)}>{"خط‌زنی"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '300px', color: 'black'}} onClick={() => setSubExam(12)}>{"عمومی"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '325px', color: 'black'}} onClick={() => setSubExam(13)}>{"حساب"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '350px', color: 'black'}} onClick={() => setSubExam(14)}>{"استدلال"}</a>}
                        {showTestList && <a style={{position: 'absolute', width: '75px', top: '375px', color: 'black'}} onClick={() => setSubExam(15)}>{"ارسال"}</a>}
                    </div>
                    <div onClick={() => saveScore()}><AiOutlineSave></AiOutlineSave></div>
                </div>
                <div className='container-screening-question' style={{height: '40%'}}>
                    <div className='screening-test-question' style={{flexDirection: 'column', alignItems: 'center', background: '#b3e0ff'}}>
                        <img src={images[counts].image} style={{maxWidth: '80%', overflowY: 'auto'}}></img>
                    </div>
                </div>
                <div className='container-screening-answer' style={{height: '50%', justifyContent: 'center'}}>
                    {show1Score &&
                    <button onClick={() => setScore(1)} className='screening-answer-option mode-bg-11'>{"یک نمره"}</button>
                    }
                    {show0Score &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"صفر نمره"}</button>
                    }
                    {showNextButton &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"بعدی"}</button>
                    }
                    {showStartButton &&
                    <button onClick={() => setScore(0)} className='screening-answer-option mode-bg-11'>{"شروع"}</button>
                    }
                </div>
            </div>
        )
    }

    return (
        <div className='test-container'>
            <div className='container-screening-question h-100'>
                <div className='screening-test-question' style={{flexDirection: 'column', alignItems: 'center', marginTop: '1.75em', marginBottom: '1.75em', background: '#b3e0ff'}}>
                    {counts == 0 &&
                    <img src={images[counts].image} style={{maxWidth: '80%', overflowY: 'auto'}}></img>
                    }
                </div>
            </div>
        </div>
    )
}

export default WiscIVSequencing